export default "__VITE_ASSET__t3DjQsIc__"